// @ts-nocheck
import React from 'react';
import { FormGroup, Intent, Classes } from '@blueprintjs/core';
import classNames from 'classnames';

import { CellType } from '@/constants';
import { FundSuggestField } from '../Funds';

/**
 * Funds list field cell.
 * @returns {JSX.Element}
 */
export default function FundsListFieldCell({
  column: { id },
  row: { index, original },
  payload: { funds, updateData, errors },
}) {
  const handleFundSelected = React.useCallback(
    (fund) => {
      updateData(index, 'fund_id', fund.id);
    },
    [updateData, index],
  );

  const error = errors?.[index]?.[id];
  // console.log("original", original)

  return (
    <FormGroup
      intent={error ? Intent.DANGER : null}
      className={classNames(
        'form-group--select-list',
        'form-group--funds-list',
        Classes.FILL,
      )}
    >
      <FundSuggestField
        funds={funds}
        onFundSelected={handleFundSelected}
        selectedFundId={original?.fund_id}
      />
    </FormGroup>
  );
}

FundsListFieldCell.cellType = CellType.Field; 